import React from "react";
import ReactHtmlParser from 'react-html-parser';

import formattingStyle from "../../styles/formatting";

import Calendar from 'react-calendar';

import SearchProject from "../projects/search";
import TextField from "@material-ui/core/TextField";
import formStyle from "../../styles/forms";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from "@material-ui/core/Grid";
import gridStyle from '../../styles/grids';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import Holiday from '../users/holiday';
import Dockter from '../users/docter';
import Baby from '../users/baby';

import Menu from "../workorderitems/workorderitemeditmenu";


import CloudOff from "@material-ui/icons/CloudOff";

import Upload from "../documents/upload";
import DocumentItems from "../documents/list";
import Signature from "../drawing/signature";

import ClientInfo from "../clients/info";

import moment from 'moment';
import 'moment/locale/nl';
moment.locale('nl');

let timeList = '';
let timeListArray = [];
for (let t = 0; t < 1440; t = t + 15) {
  timeListArray.push({ text: t + ' minuten / ' + (t / 60) + ' uur', val: t });
}
timeList = timeListArray.map((item) => {
  return (<MenuItem value={item.val} key={item.val}> {item.text}</MenuItem>)
})

let timeListTravel = '';
let timeListTravelArray = [];
for (let t = 0; t < 1440; t = t + 15) {
  timeListTravelArray.push({ text: t + ' minuten / ' + (t / 60) + ' uur', val: (t / 60) });
}
timeListTravel = timeListTravelArray.map((item) => {
  return (<MenuItem value={item.val} key={item.val}> {item.text}</MenuItem>)
})

class WorkorderItemEdit extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showDate: false, showProjectSearch: false, setSignature: false };
  }
  save = (ev) => {
    this.props.save(this.props.orderitem);
  }
  update = (ev) => {
    let item = Object.assign({}, this.props.orderitem);
    item[ev.target.id] = ev.target.value;
    this.props.update(item);
  }
  updateDate = (selectedDate) => {
    let item = Object.assign({}, this.props.orderitem);
    item.date = moment(selectedDate).toDate();
    this.props.update(item);
    this.setState({ showDate: false });
    this.props.save(item);
  }
  updateMinutes = (ev) => {
    let item = Object.assign({}, this.props.orderitem);
    item.minutes = ev.target.value;
    this.props.update(item);
  }
  updateMinutesOvertime = (ev) => {
    let item = Object.assign({}, this.props.orderitem);
    item.minutesovertime = ev.target.value;
    this.props.update(item);
  }
  updateRaceMinutes = (ev) => {
    let item = Object.assign({}, this.props.orderitem);
    item.raceminutes = ev.target.value;
    this.props.update(item);
  }
  updateLocation = (ev) => {
    let item = Object.assign({}, this.props.orderitem);
    item.location = ev.target.value;
    this.props.update(item);
  }
  updateDriverOption = (ev) => {
    let item = Object.assign({}, this.props.orderitem);
    item.driveroption = ev.target.value;
    this.props.update(item);
  }
  updateTravel = (ev) => {
    let item = Object.assign({}, this.props.orderitem);
    item.travelhours = ev.target.value;
    this.props.update(item);
  }

  delete = () => {

    this.props.delete(this.props.orderitem);
  }
  setProjectID = (project) => {
    this.setState({ showProjectSearch: false });
    let item = Object.assign({}, this.props.orderitem);

    item.project = project;
    if (project.client) {
      item.setkm = project.client.setkm;
      item.setnights = project.client.setnights;
      item.setautograph = project.client.setautograph;
      item.settravelhours = project.client.settravelhours;
      item.setpurchasenr = project.client.setpurchasenr;
      item.setraceminutes = project.client.setraceminutes;
    }

    this.props.update(item);
  }
  handleUploadedFile = (key) => {
    let item = Object.assign({}, this.props.orderitem);
    if (!item.attachments) { item.attachments = [] };
    item.attachments.push(key);
    this.props.update(item);
    this.props.save(item);
    this.props.handleMessage({ title: "Document is toegevoegd" });
  }
  handleDeleteUploadedFile = (key) => {
    let item = Object.assign({}, this.props.orderitem);
    if (!item.attachments) { item.attachments = [] };
    for (let i = item.attachments.length; i >= 0; i--) {
      if (item.attachments[i] === key) {
        item.attachments.splice(i, 1);
      }
    }
    this.props.update(item);
    this.props.save(item);
  }
  handleSaveSignature = (signature) => {
    let item = Object.assign({}, this.props.orderitem);
    item.signature = signature.outerHTML
    this.props.update(item);
    this.props.save(item);
    this.props.handleMessage({ title: "De opdracht is ondertekend" });
  }

  //this.props.orderitem.project.isdocter  this.props.orderitem.project.isholiday  this.props.orderitem.project.isbaby



  render() {

    return (
      <React.Fragment>

        {this.state.showProjectSearch && <SearchProject save={this.setProjectID} onClose={() => { this.setState({ showProjectSearch: false }) }} projects={this.props.projects} />}

        {!this.props.readonly &&
          <Menu orderItem={this.props.orderitem} style={{ float: 'right' }} handleDelete={this.delete} handleProject={() => this.setState({ showProjectSearch: true })} handleDate={() => this.setState({ showDate: !this.state.showDate })} handleSignature={() => { this.setState({ setSignature: true }) }} fileUploadId={'fileupload_' + this.props.orderitem.guid} />
        }
        {
          this.state.showDate &&
          <Dialog open={true}>
            <Calendar
              onChange={this.updateDate}
              value={moment(this.props.orderitem.date).toDate()}
            />
          </Dialog>
        }

        <form style={formStyle.container} noValidate autoComplete="off">

          <Grid container spacing={8}>
            <Grid item xs={12} md={12} style={gridStyle.item}>
              {!this.props.orderitem._id && <CloudOff style={{ float: 'right', color: 'silver' }} />}
              <div style={formattingStyle.header}>{this.props.orderitem.project ? this.props.orderitem.project.projectnumber + ' - ' + this.props.orderitem.project.name : "<Klik in het menu om een project te selecteren>"}</div>
              <div className="label">{this.props.orderitem.project.client && <ClientInfo client={this.props.orderitem.project.client} project={this.props.orderitem.project}></ClientInfo>}</div>
            </Grid>



            {this.props.orderitem.project
              &&
              <React.Fragment>
                {this.props.orderitem.project.isholiday &&
                  <Grid item xs={12} md={12} style={gridStyle.item}>
                    <div className="label">Vakantieuren</div>
                    <Holiday user={this.props.orderitem.user} holidays={this.props.holidays} readonly={true}></Holiday>
                  </Grid>
                }
                {this.props.orderitem.project.isbaby &&
                  <Grid item xs={12} md={12} style={gridStyle.item}>
                    <div className="label">Ouderschapsverlof</div>
                    <Baby user={this.props.orderitem.user} babies={this.props.babies} readonly={true}></Baby>
                  </Grid>
                }
                {this.props.orderitem.project.isdocter &&
                  <Grid item xs={12} md={12} style={gridStyle.item}>
                    <div className="label">Tandarts/huisarts/specialist</div>
                    <Dockter user={this.props.orderitem.user} docters={this.props.docters} readonly={true}></Dockter>
                  </Grid>
                }
                <Grid item xs={"auto"} md={"auto"} style={gridStyle.item}>
                  <TextField
                    multiline
                    id="materials"
                    label="Materiaal"
                    type="text"
                    value={this.props.orderitem.materials || ""}
                    onChange={this.update}
                    onBlur={this.save}
                    style={formStyle.textField}
                    InputProps={{
                      readOnly: (this.props.readonly || false),
                    }}
                  />
                  <TextField
                    multiline
                    id="remarks"
                    label="Opmerkingen"
                    type="text"
                    value={this.props.orderitem.remarks || ""}
                    onChange={this.update}
                    onBlur={this.save}
                    style={formStyle.textField}
                    InputProps={{
                      readOnly: (this.props.readonly || false),
                    }}
                  />
                </Grid>
                <Grid item xs={"auto"} md={"auto"} style={gridStyle.item}>
                  <FormControl >
                    <InputLabel htmlFor="minutes">Tijd</InputLabel>
                    <Select
                      style={formStyle.selectField}
                      value={this.props.orderitem.minutes || 0}
                      onChange={this.updateMinutes}
                      onBlur={this.save}
                      readOnly={(this.props.readonly || false)}
                      inputProps={{
                        name: 'minutes',
                        id: 'minutes'
                      }}
                    >
                      {timeList}
                    </Select>
                  </FormControl >
                  <br />
                  <FormControl style={{ width: '100%' }} >
                    <InputLabel htmlFor="minutesovertime">Overuren (na 17.00)</InputLabel>
                    <Select
                      style={formStyle.selectField}
                      value={this.props.orderitem.minutesovertime || 0}
                      onChange={this.updateMinutesOvertime}
                      onBlur={this.save}
                      readOnly={(this.props.readonly || false)}
                      inputProps={{
                        name: 'minutesovertime',
                        id: 'minutesovertime'
                      }}
                    >
                      {timeList}
                    </Select>
                  </FormControl>
                  <br />
                  {this.props.orderitem.setraceminutes
                    &&
                    <FormControl style={{ width: '100%' }} >
                      <InputLabel htmlFor="raceminutes">Gasgeven</InputLabel>
                      <Select
                        style={formStyle.selectField}
                        value={this.props.orderitem.raceminutes || 0}
                        onChange={this.updateRaceMinutes}
                        onBlur={this.save}
                        readOnly={(this.props.readonly || false)}
                        inputProps={{
                          name: 'raceminutes',
                          id: 'raceminutes'
                        }}
                      >
                        {timeList}
                      </Select>
                    </FormControl>
                  }

                </Grid>
                <Grid item xs={"auto"} md={"auto"} style={gridStyle.item}>
                  <FormControl required>
                    <InputLabel htmlFor="location">Locatie</InputLabel>
                    <Select
                      style={this.props.orderitem.location === 0 ? formStyle.selectFieldError : formStyle.selectField}
                      value={this.props.orderitem.location || 0}
                      onChange={this.updateLocation}
                      onBlur={this.save}

                      inputProps={{
                        name: 'location',
                        id: 'location'
                      }}
                    >
                      <MenuItem value={0} > Selecteer locatie</MenuItem>
                      <MenuItem value={1} > Werkplaats</MenuItem>
                      <MenuItem value={2} > Montage/locatie</MenuItem>
                    </Select>
                  </FormControl >
                  <br />
                  {this.props.orderitem.setkm
                    &&
                    <FormControl >
                      <TextField
                        id="kilometers"
                        label="Kilometers"
                        type="number"
                        value={this.props.orderitem.kilometers || ""}
                        onChange={this.update}
                        onBlur={this.save}
                        style={formStyle.textField}
                        InputProps={{
                          readOnly: (this.props.readonly || false),
                        }}
                      />
                    </FormControl >
                  }


                </Grid>
                {this.props.orderitem.location && this.props.orderitem.location === 2 &&
                  <Grid item xs={"auto"} md={"auto"} style={gridStyle.item}>
                    <FormControl required>
                      <InputLabel htmlFor="driveroption">Zelf gereden of meegereden</InputLabel>
                      <Select
                        style={this.props.orderitem.driveroption === -1 ? formStyle.selectFieldError : formStyle.selectField}
                        value={this.props.orderitem.driveroption || -1}
                        onChange={this.updateDriverOption}
                        onBlur={this.save}

                        inputProps={{
                          name: 'driveroption',
                          id: 'driveroption'
                        }}
                      >
                        <MenuItem value={-1} > Selecteer optie</MenuItem>
                        <MenuItem value={1} > Zelf gereden</MenuItem>
                        <MenuItem value={2} > Meegereden met</MenuItem>
                      </Select>
                    </FormControl >
                    <br />
                    {this.props.orderitem.driveroption && this.props.orderitem.driveroption === 2
                      &&
                      <FormControl >
                        <TextField
                          id="driver"
                          label="Meegereden met"
                          type="text"
                          value={this.props.orderitem.driver || ""}
                          onChange={this.update}
                          onBlur={this.save}
                          style={formStyle.textField}
                          InputProps={{
                            readOnly: (this.props.readonly || false),
                          }}
                        />
                      </FormControl >
                    }


                  </Grid>
                }
                <Grid item xs={"auto"} md={"auto"} style={gridStyle.item}>
                  {this.props.orderitem.setnights
                    &&
                    <React.Fragment>
                      <FormControl >
                        <TextField
                          id="nights"
                          label="Aantal overnachtingen"
                          type="number"
                          value={this.props.orderitem.nights || ""}
                          onChange={this.update}
                          onBlur={this.save}
                          style={formStyle.textField}
                          InputProps={{
                            readOnly: (this.props.readonly || false),
                          }}
                        />
                      </FormControl><br />
                    </React.Fragment>
                  }
                  {this.props.orderitem.settravelhours
                    &&
                    <FormControl >
                      <InputLabel htmlFor="travelhours">Reisuren</InputLabel>
                      <Select
                        style={formStyle.selectField}
                        value={this.props.orderitem.travelhours || 0}
                        onChange={this.updateTravel}
                        onBlur={this.save}
                        readOnly={(this.props.readonly || false)}
                        inputProps={{
                          name: 'travelhours',
                          id: 'travelhours'
                        }}
                      >
                        {timeListTravel}
                      </Select>
                    </FormControl >

                  }
                </Grid>
              </React.Fragment>
            }
          </Grid>

        </form>
        {this.props.orderitem.attachments.length > 0 && <div className="label">Bijlagen</div>}
        <DocumentItems items={this.props.orderitem.attachments} handleDelete={this.handleDeleteUploadedFile} readOnly={this.props.readonly || false} />
        {!this.props.readonly && <Upload handleUploadedFile={this.handleUploadedFile} id={'fileupload_' + this.props.orderitem.guid} ></Upload>}
        {
          this.state.setSignature
          && <Signature handleClose={() => this.setState({ setSignature: false })} handleSave={this.handleSaveSignature} />
        }

        {this.props.orderitem.signature && <div className="label">Handtekening</div>}
        {ReactHtmlParser(this.props.orderitem.signature)}
        <br />
        <Divider />
        <br />

      </React.Fragment>
    );
  }
}
export default WorkorderItemEdit;
